"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLandAreaInputProps = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _types = require("../../../actions/filters/types");
var _analytics = require("../../../analytics");
var _selectors = require("../../../selectors");
var _useActions = require("./useActions");
var _units = require("../../../constants/units");
var _intOnly = require("../../../utils/formatters/intOnly");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** Пропсы для фильтра площади дома */
const useLandAreaInputProps = _ref => {
  let {
    isMyHome
  } = _ref;
  const {
    landArea,
    errorTooltip,
    userSetArea,
    estimationTarget
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);
  const {
    setError,
    setUserAreaFlag,
    setLandArea
  } = (0, _useActions.useActions)();

  /** Функции аналитики отличаеются для моего дома */
  const submitAnalytics = isMyHome ? _analytics.getTrackMyHomeLandAreaPick : _analytics.getTrackLandAreaPick;

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === _types.ECurrentErrorField.landArea ? errorTooltip.errorText : '';

  /** Обработчик ввода в инпут Площади */
  const onValueChange = React.useCallback(value => {
    const intVal = (0, _intOnly.intOnly)(value);
    setLandArea({
      landArea: Number(intVal)
    });
    if (!userSetArea) {
      setUserAreaFlag({
        userSetArea: true
      });
    }
    if (errorMessage) {
      setError({
        currentErrorField: _types.ECurrentErrorField.landArea,
        errorText: ''
      });
    }
  }, [errorMessage, userSetArea, setLandArea, setError, setUserAreaFlag]);
  return {
    value: landArea ? String(landArea) : '',
    unit: _units.EUnits.sotki,
    errorMessage,
    onValueChange,
    onBlur: submitAnalytics(estimationTarget),
    shouldShowUnit: true,
    placeholder: '10'
  };
};
exports.useLandAreaInputProps = useLandAreaInputProps;